
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"35","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#444","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M18.333 15.796v4.534h9.716l-.134.865c-.669 4.31-4.476 8.118-10.572 8.118-6.342 0-11.46-5.258-11.46-11.773s5.118-11.773 11.46-11.773c2.784 0 5.064.91 6.849 2.383l3.639-3.539C24.88 2.108 21.316.75 17.356.75 8.132.905.75 8.336.75 17.54c0 9.242 7.418 16.71 16.593 16.71 10.526 0 17.102-8.45 15.74-18.454h-14.75z","stroke-width":"1.5"}}),_c('g',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M42.6 16v-4c0-2.2 1.755-4 3.9-4s3.9 1.8 3.9 4v4"}}),_c('path',{attrs:{"d":"M46.5 14.667c3.59 0 6.5 2.984 6.5 6.666C53 25.015 50.09 28 46.5 28S40 25.015 40 21.333s2.91-6.666 6.5-6.666h0zM46.5 22v2"}}),_c('path',{attrs:{"d":"M46.5 18c1.077 0 1.95.895 1.95 2s-.873 2-1.95 2-1.95-.895-1.95-2 .873-2 1.95-2h0z"}})])])])
          )
        }
      }
    